import type { IStockRepository, AssetUpdateInput } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockAssetEntity } from '@/features/stock/domain/entities/StockEntity.js';

export interface UpdateAssetInput { id: string; data: AssetUpdateInput; }
interface Deps { stockRepository: IStockRepository; }

export function createUpdateAssetUseCase({ stockRepository }: Deps) {
  return async function updateAsset({ id, data }: UpdateAssetInput): Promise<StockAssetEntity | null> {
    return stockRepository.updateAsset(id, data);
  };
}
